import type { RootState } from "../../store/types";

export function getInstanceId(state: RootState): string {
  return state.userInstance.connectedInstance?.instanceId ?? "";
}
